"use client";

import * as React from "react";
import dayjs from "dayjs";
import { Calendar } from "@/components/ui/calendar";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDownIcon } from "lucide-react";

export function DatePicker({
  initialDate,
  onChange,
  hideArrow,
  startMonth,
  endMonth,
}: {
  initialDate: string | null;
  onChange?: (date: string) => void;
  hideArrow?: boolean;
  startMonth?: Date;
  endMonth?: Date;
}) {
  const [date, setDate] = useState<string | null>(initialDate);
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        className="w-full justify-between font-normal hover:scale-100!"
        onClick={() => setVisible(!visible)}
        type={"button"}
      >
        {date === null || date === undefined || date === ""
          ? "Wybierz datę"
          : date}
        {!hideArrow && <ChevronDownIcon />}
      </Button>
      {visible && (
        <Calendar
          endMonth={endMonth}
          startMonth={startMonth}
          className={"absolute z-1000 mt-1 rounded-md shadow-sm"}
          mode="single"
          selected={date ? new Date(date) : undefined}
          captionLayout="dropdown"
          onSelect={(date) => {
            if (!date) {
              return;
            }
            const newDate = dayjs(date).format("DD-MM-YYYY");
            setDate(newDate);
            if (onChange) {
              onChange(newDate);
            }
            setVisible(false);
          }}
        />
      )}
    </>
  );
}
